import { Table } from "antd";
import React, { FC } from "react";
import { CreditworthinessAggregatedBalanceSheet } from "../../../../../../../store/types/scoring.type";

const columns = [
  {
    title: "№",
    dataIndex: "key",
    width: 50,
  },
  {
    title: "Наименование статьи",
    dataIndex: "title",
  },
  {
    title: "01.01.2023",
    dataIndex: "lc",
    width: 115,
  },
  {
    title: "Изменение, %",
    dataIndex: "result",
    width: 115,
  },
  {
    title: "01.07.2023",
    dataIndex: "rc",
    width: 115,
  },
  {
    title: "Доля в ВБ",
    dataIndex: "share",
    width: 115,
  },
];

interface AggregateBalanceTableProps {
  dataSource: CreditworthinessAggregatedBalanceSheet[];
}

export const AggregateBalanceTable: FC<AggregateBalanceTableProps> = (
  props
) => {
  const { dataSource } = props;

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      bordered
      pagination={false}
    />
  );
};
